<div class="loader-container dark:text-white main-bg page-height">
  <div class="loader"></div>
  Getting {{ text }} ready...
</div>
